import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ItemRadioComponent } from './item-radio.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [ItemRadioComponent],
    exports: [ItemRadioComponent]
})
export class ItemRadioModule {}
